<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }} - Départ 9h30</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <p>
            La première édition de l’Escapade s’est courue le 13 novembre 1994, sous l’impulsion de quelques passionnés tels qu’Henri MEZZANA et Serge SARDE. Nous en sommes aujourd’hui à la 28ème (5 novembre 2023).<br />
            L'Escapade d'Ensuès est une des plus belles et des plus réputées des compétitions du département des Bouches du Rhône. C'est grâce à plus de 80 bénévoles et commissaires de course du village d'Ensuès que cette épreuve peut être réussie.
            Le parcours, qui n’a pratiquement pas changé depuis presque trente ans, a été tracé dans les collines de la commune d’Ensuès. Sur 12,200 km se déroulent sous les pieds des sportifs les plus beaux sites de la Côte Bleue.<br />
            Le départ et l’arrivée se font depuis la place de l’hôtel de ville, où sont également remises les récompenses (coupes, médailles et bouquets de fleurs) aux vainqueurs de chaque catégorie et aux trois premiers du classement au scratch
            hommes et femmes. Un challenge du plus grand nombre de coureurs par club est également attribué.
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="4"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/ESC_2649_Pic.jpg" alt="" />
        </b-col>
        <!--     <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col> -->
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Serge SARDE (Tel 06-23-98-06-64, mail : serge.sarde@sfr.fr)</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/activity_4217278925.gpx" target="_blank">GPX de l'épreuve</b-button>
          <b-button class="infos_btn" href="http://bernard.chappe.free.fr/escapade/escapade.htm" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="https://www.courirenfrance.com/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>